// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainPage_mainContainer__P6i7f {

    margin-left: 5px;
    margin-right: 5px;
    margin-top: 5px;
    display: flex;

    overflow: hidden;
    
    border-top-width: 5px;
    border-right-width: 4px;
    border-bottom-width: 8px;
    border-radius: 32px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    min-height: 100svh;
    padding: 20px;
    flex-direction: column;
    
}

.MainPage_containerTool__fvip6 {
    position: fixed;
    bottom: 60px;
    right: 300px;
    margin: 10px;
    z-index: 3;
}

.MainPage_bottomFooter__sCfC5 {
    margin-top: 80px;
}

.MainPage_wrapperCard__32sGY {
    width: calc(22%);
}

.MainPage_NameNoSlots__m1Yxl {
    margin-top: 30px;
    font-family: Poppins, sans-serif;
    font-weight: 600;
    font-size: 20px;
    color: white;
}

.MainPage_containerSlots__RruL2 {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
    z-index: 2;

}

@keyframes MainPage_ApperAnimate__MnDxH {
    0% {
        display: none;

    }

    100% {
        display: flex;

    }
}

.MainPage_containerSearches__FgTL1 {
    position: sticky;
    top:80px;
    z-index: 5;
    width: 100%;
    display: flex;

    justify-content: center;
    flex-wrap: wrap-reverse;
    gap: 1rem;
}

.MainPage_containerLikeButton__lCSme {
    
    color: #ec2929;
    ;
    font-size: 50px;
    cursor: pointer;
}

.MainPage_parent__2jNMP {
    
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
    width: 100%;
    border-radius: 16px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    background: radial-gradient(99.25% 100% at 50% 0%, rgb(36, 43, 83) 0%, rgb(31, 38, 76) 100%);
    /* background: #0c1432; */
    /* box-shadow: rgba(15, 17, 33, 0.04) 0px 8px 16px -4px, rgba(0, 0, 0, 0.12) 0px -2px 0px 0px inset; */
    box-shadow: 0px 0px 8px 2px #000;
    
    gap: 8px;

}

.MainPage_blockProviders__HN-vi {
    position: absolute;
    top:80px;
    max-width: 1000px;
    width: 100%;

    background-color: #0f1127;
    border-radius: 8px;
    font-family: Poppins, sans-serif;
    font-weight: 500;
    transition: opacity 0.5s ease;
    z-index: 1;
    display: flex;
    flex-wrap: wrap;
    opacity: 0;
    pointer-events: none; /* %D0%92%D0%BA%D0%BB%D1%8E%D1%87%D0%B0%D0%B5%D0%BC %D0%BA%D0%BB%D0%B8%D0%BA%D0%B8 */



}

.MainPage_blockProviders__HN-vi.MainPage_active__XOwiI {
    pointer-events: auto; /* %D0%92%D0%BA%D0%BB%D1%8E%D1%87%D0%B0%D0%B5%D0%BC %D0%BA%D0%BB%D0%B8%D0%BA%D0%B8 */

    opacity: 1;
    z-index: 4;

}

.MainPage_blockProviders__HN-vi.MainPage_unactive__1n\\+9- {
    opacity: 0;
    z-index: 1;
    pointer-events: none; /* %D0%92%D0%BA%D0%BB%D1%8E%D1%87%D0%B0%D0%B5%D0%BC %D0%BA%D0%BB%D0%B8%D0%BA%D0%B8 */

}

.MainPage_block__MIXbw {
    color: white;
    padding: 10px;

    cursor: pointer;
    border-radius: 5px;
    width: 25%;

}

.MainPage_block__MIXbw.MainPage_active__XOwiI {
    background-color: #3645c5;

}

.MainPage_block__MIXbw:hover {
    background-color: #3645c5;


}

@media only screen and (max-width: 1517px) {
    .MainPage_wrapperCard__32sGY {
        width: calc(25% - 13px);

    }
}

@media only screen and (max-width: 1000px) {
    .MainPage_wrapperCard__32sGY {
        width: calc(30% - 12px);

    }
}

@media screen and (max-width: 799px) {
    .MainPage_mainContainer__P6i7f {
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 40px;
        padding: 10px;
        margin-top: 60px;
    }

    .MainPage_blockProviders__HN-vi {
        margin-top: 120px;
        max-width: 100%;
    }
    .MainPage_parent__2jNMP{
        border-radius: 0;
    }

    .MainPage_containerSearches__FgTL1 {
        flex-direction: column-reverse;
        justify-content: center;
        align-items: center;
        gap:10px;
    }

    .MainPage_block__MIXbw {
        width: 50%;
    }

    .MainPage_wrapperCard__32sGY {
        width: calc(40% - 12px);

    }

}

@media only screen and (max-width: 1000px) {
    
    .MainPage_containerTool__fvip6 {
        position: fixed;
        bottom: 60px;
        right: 0;
        margin: 10px;
        z-index: 3;
    }

    .MainPage_containerLikeButton__lCSme {
z-index: 9;
        margin-top: 20px;
        font-size: 35px !important;
    }

    .MainPage_containerSlots__RruL2 {
        gap: 10px;
    }

    .MainPage_mainContainer__P6i7f {
        padding: 5px;
    }

    .MainPage_wrapperCard__32sGY {
        width: calc(50% - 5px);

    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/SlotsIgrator/components/MainPage/MainPage.module.css"],"names":[],"mappings":"AAAA;;IAEI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,aAAa;;IAEb,gBAAgB;;IAEhB,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,sBAAsB;;AAE1B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,UAAU;;AAEd;;AAEA;IACI;QACI,aAAa;;IAEjB;;IAEA;QACI,aAAa;;IAEjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,aAAa;;IAEb,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;AACb;;AAEA;;IAEI,cAAc;;IAEd,eAAe;IACf,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,4BAA4B;IAC5B,6BAA6B;IAC7B,4FAA4F;IAC5F,yBAAyB;IACzB,sGAAsG;IACtG,gCAAgC;;IAEhC,QAAQ;;AAEZ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;IACjB,WAAW;;IAEX,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;IACV,aAAa;IACb,eAAe;IACf,UAAU;IACV,oBAAoB,EAAE,oFAAoF;;;;AAI9G;;AAEA;IACI,oBAAoB,EAAE,oFAAoF;;IAE1G,UAAU;IACV,UAAU;;AAEd;;AAEA;IACI,UAAU;IACV,UAAU;IACV,oBAAoB,EAAE,oFAAoF;;AAE9G;;AAEA;IACI,YAAY;IACZ,aAAa;;IAEb,eAAe;IACf,kBAAkB;IAClB,UAAU;;AAEd;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,yBAAyB;;;AAG7B;;AAEA;IACI;QACI,uBAAuB;;IAE3B;AACJ;;AAEA;IACI;QACI,uBAAuB;;IAE3B;AACJ;;AAEA;IACI;QACI,cAAc;QACd,eAAe;QACf,mBAAmB;QACnB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;QAC9B,uBAAuB;QACvB,mBAAmB;QACnB,QAAQ;IACZ;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,uBAAuB;;IAE3B;;AAEJ;;AAEA;;IAEI;QACI,eAAe;QACf,YAAY;QACZ,QAAQ;QACR,YAAY;QACZ,UAAU;IACd;;IAEA;AACJ,UAAU;QACF,gBAAgB;QAChB,0BAA0B;IAC9B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,sBAAsB;;IAE1B;AACJ","sourcesContent":[".mainContainer {\n\n    margin-left: 5px;\n    margin-right: 5px;\n    margin-top: 5px;\n    display: flex;\n\n    overflow: hidden;\n    \n    border-top-width: 5px;\n    border-right-width: 4px;\n    border-bottom-width: 8px;\n    border-radius: 32px;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    min-height: 100svh;\n    padding: 20px;\n    flex-direction: column;\n    \n}\n\n.containerTool {\n    position: fixed;\n    bottom: 60px;\n    right: 300px;\n    margin: 10px;\n    z-index: 3;\n}\n\n.bottomFooter {\n    margin-top: 80px;\n}\n\n.wrapperCard {\n    width: calc(22%);\n}\n\n.NameNoSlots {\n    margin-top: 30px;\n    font-family: Poppins, sans-serif;\n    font-weight: 600;\n    font-size: 20px;\n    color: white;\n}\n\n.containerSlots {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 15px;\n    z-index: 2;\n\n}\n\n@keyframes ApperAnimate {\n    0% {\n        display: none;\n\n    }\n\n    100% {\n        display: flex;\n\n    }\n}\n\n.containerSearches {\n    position: sticky;\n    top:80px;\n    z-index: 5;\n    width: 100%;\n    display: flex;\n\n    justify-content: center;\n    flex-wrap: wrap-reverse;\n    gap: 1rem;\n}\n\n.containerLikeButton {\n    \n    color: #ec2929;\n    ;\n    font-size: 50px;\n    cursor: pointer;\n}\n\n.parent {\n    \n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 12px;\n    width: 100%;\n    border-radius: 16px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    background: radial-gradient(99.25% 100% at 50% 0%, rgb(36, 43, 83) 0%, rgb(31, 38, 76) 100%);\n    /* background: #0c1432; */\n    /* box-shadow: rgba(15, 17, 33, 0.04) 0px 8px 16px -4px, rgba(0, 0, 0, 0.12) 0px -2px 0px 0px inset; */\n    box-shadow: 0px 0px 8px 2px #000;\n    \n    gap: 8px;\n\n}\n\n.blockProviders {\n    position: absolute;\n    top:80px;\n    max-width: 1000px;\n    width: 100%;\n\n    background-color: #0f1127;\n    border-radius: 8px;\n    font-family: Poppins, sans-serif;\n    font-weight: 500;\n    transition: opacity 0.5s ease;\n    z-index: 1;\n    display: flex;\n    flex-wrap: wrap;\n    opacity: 0;\n    pointer-events: none; /* %D0%92%D0%BA%D0%BB%D1%8E%D1%87%D0%B0%D0%B5%D0%BC %D0%BA%D0%BB%D0%B8%D0%BA%D0%B8 */\n\n\n\n}\n\n.blockProviders.active {\n    pointer-events: auto; /* %D0%92%D0%BA%D0%BB%D1%8E%D1%87%D0%B0%D0%B5%D0%BC %D0%BA%D0%BB%D0%B8%D0%BA%D0%B8 */\n\n    opacity: 1;\n    z-index: 4;\n\n}\n\n.blockProviders.unactive {\n    opacity: 0;\n    z-index: 1;\n    pointer-events: none; /* %D0%92%D0%BA%D0%BB%D1%8E%D1%87%D0%B0%D0%B5%D0%BC %D0%BA%D0%BB%D0%B8%D0%BA%D0%B8 */\n\n}\n\n.block {\n    color: white;\n    padding: 10px;\n\n    cursor: pointer;\n    border-radius: 5px;\n    width: 25%;\n\n}\n\n.block.active {\n    background-color: #3645c5;\n\n}\n\n.block:hover {\n    background-color: #3645c5;\n\n\n}\n\n@media only screen and (max-width: 1517px) {\n    .wrapperCard {\n        width: calc(25% - 13px);\n\n    }\n}\n\n@media only screen and (max-width: 1000px) {\n    .wrapperCard {\n        width: calc(30% - 12px);\n\n    }\n}\n\n@media screen and (max-width: 799px) {\n    .mainContainer {\n        margin-left: 0;\n        margin-right: 0;\n        margin-bottom: 40px;\n        padding: 10px;\n        margin-top: 60px;\n    }\n\n    .blockProviders {\n        margin-top: 120px;\n        max-width: 100%;\n    }\n    .parent{\n        border-radius: 0;\n    }\n\n    .containerSearches {\n        flex-direction: column-reverse;\n        justify-content: center;\n        align-items: center;\n        gap:10px;\n    }\n\n    .block {\n        width: 50%;\n    }\n\n    .wrapperCard {\n        width: calc(40% - 12px);\n\n    }\n\n}\n\n@media only screen and (max-width: 1000px) {\n    \n    .containerTool {\n        position: fixed;\n        bottom: 60px;\n        right: 0;\n        margin: 10px;\n        z-index: 3;\n    }\n\n    .containerLikeButton {\nz-index: 9;\n        margin-top: 20px;\n        font-size: 35px !important;\n    }\n\n    .containerSlots {\n        gap: 10px;\n    }\n\n    .mainContainer {\n        padding: 5px;\n    }\n\n    .wrapperCard {\n        width: calc(50% - 5px);\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `MainPage_mainContainer__P6i7f`,
	"containerTool": `MainPage_containerTool__fvip6`,
	"bottomFooter": `MainPage_bottomFooter__sCfC5`,
	"wrapperCard": `MainPage_wrapperCard__32sGY`,
	"NameNoSlots": `MainPage_NameNoSlots__m1Yxl`,
	"containerSlots": `MainPage_containerSlots__RruL2`,
	"containerSearches": `MainPage_containerSearches__FgTL1`,
	"containerLikeButton": `MainPage_containerLikeButton__lCSme`,
	"parent": `MainPage_parent__2jNMP`,
	"blockProviders": `MainPage_blockProviders__HN-vi`,
	"active": `MainPage_active__XOwiI`,
	"unactive": `MainPage_unactive__1n+9-`,
	"block": `MainPage_block__MIXbw`,
	"ApperAnimate": `MainPage_ApperAnimate__MnDxH`
};
export default ___CSS_LOADER_EXPORT___;
